import React from "react";
import FontAwesome from "react-fontawesome";

const PermitList = ({ list }) => {
  return (
    <div>
      {list && list.length > 0 && (
        <div>
          <div className="container-fluid">
            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <span
                  className="text-dark"
                  style={{ fontSize: "14px",fontWeight: "bold" }}
                >
                  {list[0].customer_code}
                </span>
              </div>

              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal"> {list[0].customer_name}</p>
              </div>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  {"สินค้า"}{" "}
                  <span
                    className="badge rounded-pill bg-primary"
                    style={{ fontSize: "13px" }}
                  >
                    {list[0].Product_name}
                  </span>
                </p>
              </div>
            </div>

            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                  {"ทะเบียนหัว"} {list[0].First_driven_no}{" "}
                  {list[0].First_driven_prov}
                </p>
              </div>

              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  {" "}
                  {"ทะเบียนหาง"} {list[0].Second_driven_no}{" "}
                  {list[0].Second_driven_prov}
                </p>
              </div>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  {" "}
                  {"ประเภทรถ"} {list[0].TruckType}{" "}
                </p>
              </div>
            </div>

            {/* <div className="row" style={{ fontSize: "14px" }}>
               <div className="col-lg-4  col-sm-6 col-xs-12">
             
                <p className="font-weight-normal">  
                <FontAwesome name ="phone-square" />  {" "}
                {list[0].driventel}</p>

              </div>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal" style={{ fontSize: "14px" }}>
                 {"ชื่อผู้ขับ"} {list[0].Driver_name}
                </p>
              </div>

             
            </div> */}

            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">เวลา.เข้า {list[0].datein}</p>
              </div>

              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">เวลา.ออก {list[0].dateout}</p>
              </div>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                {list[0].totaltime > 120 ? (
                  <span
                    className="badge bg-danger"
                    style={{ fontSize: "13px" }}
                  >
                    เวลา.รวม {list[0].totaltime} {"นาที"}
                  </span>
                ) : (
                  <span
                    className="badge  bg-warning text-dark"
                    style={{ fontSize: "13px" }}
                  >
                    เวลา.รวม {list[0].totaltime} {"นาที"}
                  </span>
                )}
              </div>
            </div>

            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-3  col-sm-6 col-xs-12">
                <p className="font-weight-normal">นน.เข้า {list[0].weightin}</p>
              </div>

              <div className="col-lg-3  col-sm-6 col-xs-12">
                <p className="font-weight-normal">นน.ออก {list[0].weightout}</p>
              </div>
              <div className="col-lg-3  col-sm-6 col-xs-12">
                <p className="font-weight-normal">ตัด {list[0].weightcut} </p>
              </div>
              <div className="col-lg-3  col-sm-6 col-xs-12">
                <p className="font-weight-normal">สุทธิ {list[0].weightnet} </p>
              </div>
            </div>

            <div className="row" style={{ fontSize: "14px" }}>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <p className="font-weight-normal">
                  ภาพรวมการชั่ง{" "}
                  {list[0].statusid === 1 ? (
                    <span
                      className="badge bg-info text-dark"
                      style={{ fontSize: "13px" }}
                    >
                      {"รอชั่งออก"}
                    </span>
                  ) : list[0].statusid === 2 ? (
                    <span
                      className="badge bg-success"
                      style={{ fontSize: "13px" }}
                    >
                      {"< 1 ชม."}
                    </span>
                  ) : list[0].statusid === 3 ? (
                    <span
                      className="badge badge text-dark"
          
                      style={{ fontSize: "13px", backgroundColor: "#42f58d" }}
                    >
                      {"1-1.5 ชม."}
                    </span>
                  ) : list[0].statusid === 4 ? (
                    <span
                      className="badge badge text-dark"
          
                      style={{ fontSize: "13px", backgroundColor: "#fcf003" }}
                    >
                      {"1.5-2.0 ชม."}
                    </span>
                  ) : (
                    <span
                      className="badge badge text-dark"
          
                      style={{ fontSize: "13px", backgroundColor: "#fc6b03" }}
                    >
                      {">2.0 ชม."}
                    </span>
                  )}
                </p>
              </div>
            </div>

            {list && list.Suppervisor && list.Suppervisor[0].ComfirmJoin && (
              <table className="table table-striped table-hover">
                <thead>
                  <tr style={{ fontSize: "14px" }}>
                    {list.PermitTypeID == "3" ? (
                      <th scope="col">
                        <FontAwesome name="user" /> ผู้ติดตาม
                      </th>
                    ) : (
                      <th scope="col">
                        <FontAwesome name="user" /> หัวหน้างาน
                      </th>
                    )}

                    <th scope="col">เลขบัตร</th>
                    <th scope="col">สถานะอบรม</th>
                    <th scope="col">สถานะบทลงโทษ</th>
                    <th scope="col">ประเมิน Covid</th>
                    <th scope="col"></th>
                    <th scope="col">เข้า</th>
                    <th scope="col">ออก</th>
                  </tr>
                </thead>
                <tbody>
                  {list &&
                  list.Suppervisor &&
                  list.Suppervisor[0].ComfirmJoin ? (
                    list.Suppervisor.map((values) => (
                      <tr key={values.IdentityID} style={{ fontSize: "14px" }}>
                        <td>{values.Fname + " " + values.Lname}</td>
                        <td style={{ fontSize: "12px" }}>
                          {" "}
                          {values.IdentityID}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {values.safety === 1 ? (
                            <span className="badge bg-success"> ผ่าน </span>
                          ) : (
                            <span className="badge bg-danger">
                              {" "}
                              ไม่ผ่าน{" "}
                            </span>
                          )}
                        </td>
                        <td>
                          {values.penaltyname === "ปกติ" ? (
                            <span className="badge bg-success">
                              {" "}
                              {values.penaltyname}
                            </span>
                          ) : values.penaltyname === "ใบแดง" ? (
                            <span className="badge bg-danger">
                              {" "}
                              {values.penaltyname}
                            </span>
                          ) : (
                            <span className="badge bg-warning">
                              {" "}
                              {values.penaltyname}
                            </span>
                          )}
                        </td>
                        <td>
                          {values.CkCovid ? (
                            <span className="badge bg-success">
                              {" "}
                              ผ่านประเมิน{" "}
                            </span>
                          ) : (
                            <span className="badge bg-danger">
                              {" "}
                              ไม่ผ่าน{" "}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="mytooltip tooltip-effect-1">
                            <span className="tooltip-item">
                              <span className="d-none d-md-inline text-black pr-2">
                                <img
                                  alt=""
                                  className="rounded-circle ms-2"
                                  src={values.url + "&size=320"}
                                  style={{
                                    width: "100%",
                                    maxHeight: 50,
                                    maxWidth: 50,
                                  }}
                                />
                              </span>
                            </span>

                            <span className="tooltip-content clearfix">
                              <img
                                alt=""
                                className="rounded-circle ms-2"
                                src={values.url + "&size=320"}
                                style={{
                                  width: "100%",
                                  minHeight: "300px",
                                  minWidth: "300px",
                                }}
                              />

                              <span className="tooltip-text"></span>
                            </span>
                          </div>
                        </td>
                        <td>
                          {values.timein ? (
                            <span className="badge bg-warning">
                              {" "}
                              {values.timein}{" "}
                            </span>
                          ) : null}
                        </td>
                        <td>
                          {values.timeout ? (
                            <span className="badge bg-warning">
                              {" "}
                              {values.timeout}{" "}
                            </span>
                          ) : null}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
            )}

            {list && list.CarList && (
              <div>
                <div className="row" style={{ fontSize: "14px" }}>
                  <div className="col-lg-4  col-sm-6 col-xs-12">
                    <p className="font-weight-normal">
                      ทะเบียนรถ:{list.CarList[0].CarLicense}
                    </p>
                  </div>
                  <div className="col-lg-4  col-sm-6 col-xs-12">
                    <p className="font-weight-normal">
                      ประเภทรถ:{list.CarList[0].CarTypeName}
                    </p>
                  </div>
                  <div className="col-lg-4  col-sm-6 col-xs-12">
                    <p className="font-weight-normal">
                      เหตผล:{list.CarList[0].remark}
                    </p>
                  </div>
                </div>

                <div className="row" style={{ fontSize: "14px" }}>
                  <div className="col-lg-4  col-sm-6 col-xs-12">
                    <p className="font-weight-normal">ยี่ห้อ:</p>
                  </div>
                  <div className="col-lg-4  col-sm-6 col-xs-12">
                    <p className="font-weight-normal">
                      {list.CarList[0].details}
                    </p>
                  </div>
                </div>

                <table className="table table-striped table-hover">
                  <thead>
                    <tr style={{ fontSize: "14px" }}>
                      <th scope="col">
                        <FontAwesome name="truck" /> คนขับ
                      </th>
                      <th scope="col">เลขบัตร</th>
                      <th scope="col">สถานะอบรม</th>
                      <th scope="col">สถานะบทลงโทษ</th>
                      <th scope="col">ประเมิน Covid</th>
                      <th scope="col"></th>
                      <th scope="col">เข้า</th>
                      <th scope="col">ออก</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list && list.CarList ? (
                      list.CarList.map((values) => (
                        <tr
                          key={values.IdentityID}
                          style={{ fontSize: "15px" }}
                        >
                          <td>{values.Fname + " " + values.Lname}</td>
                          <td style={{ fontSize: "12px" }}>
                            {values.IdentityID}
                          </td>
                          <td style={{ fontSize: "14px" }}>
                            {values.safety === 1 ? (
                              <span className="badge bg-success">
                                {" "}
                                ผ่าน{" "}
                              </span>
                            ) : (
                              <span className="badge bg-danger">
                                {" "}
                                ไม่ผ่าน{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            {values.penaltyname === "ปกติ" ? (
                              <span className="badge bg-success">
                                {" "}
                                {values.penaltyname}
                              </span>
                            ) : values.penaltyname === "ใบแดง" ? (
                              <span className="badge bg-danger">
                                {" "}
                                {values.penaltyname}
                              </span>
                            ) : (
                              <span className="badge bg-warning">
                                {" "}
                                {values.penaltyname}
                              </span>
                            )}
                          </td>
                          <td>
                            {values.CkCovid ? (
                              <span className="badge bg-success">
                                {" "}
                                ผ่านประเมิน{" "}
                              </span>
                            ) : (
                              <span className="badge bg-danger">
                                {" "}
                                ไม่ผ่าน{" "}
                              </span>
                            )}
                          </td>
                          <td>
                            <div className="mytooltip tooltip-effect-1">
                              <span className="tooltip-item">
                                <span className="d-none d-md-inline text-black pr-2">
                                  <img
                                    alt=""
                                    className="rounded-circle ms-2"
                                    src={values.url + "&size=320"}
                                    style={{
                                      width: "100%",
                                      maxHeight: 50,
                                      maxWidth: 50,
                                    }}
                                  />
                                </span>
                              </span>

                              <span className="tooltip-content clearfix">
                                <img
                                  alt=""
                                  className="rounded-circle ms-2"
                                  src={values.url + "&size=320"}
                                  style={{
                                    width: "100%",
                                    minHeight: "300px",
                                    minWidth: "300px",
                                  }}
                                />

                                <span className="tooltip-text"></span>
                              </span>
                            </div>
                          </td>
                          <td>
                            {values.timein ? (
                              <span className="badge bg-warning">
                                {" "}
                                {values.timein}{" "}
                              </span>
                            ) : null}
                          </td>
                          <td>
                            {values.timeout ? (
                              <span className="badge bg-warning">
                                {" "}
                                {values.timeout}{" "}
                              </span>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {list && list.WorkerList && (
              <table className="table table-striped table-hover">
                <thead>
                  <tr style={{ fontSize: "14px" }}>
                    <th scope="col">
                      <FontAwesome name="user" /> ผู้ปฏิบัติงาน
                    </th>
                    <th scope="col">เลขบัตร</th>
                    <th scope="col">สถานะอบรม</th>
                    <th scope="col">สถานะบทลงโทษ</th>
                    <th scope="col">ประเมิน Covid</th>

                    <th scope="col"></th>
                    <th scope="col">เข้า</th>
                    <th scope="col">ออก</th>
                  </tr>
                </thead>
                <tbody>
                  {list && list.WorkerList ? (
                    list.WorkerList.map((values) => (
                      <tr key={values.IdentityID} style={{ fontSize: "15px" }}>
                        <td>{values.Fname + " " + values.Lname}</td>
                        <td style={{ fontSize: "12px" }}>
                          {values.IdentityID}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {values.safety === 1 ? (
                            <span className="badge bg-success"> ผ่าน </span>
                          ) : (
                            <span className="badge bg-danger">
                              {" "}
                              ไม่ผ่าน{" "}
                            </span>
                          )}
                        </td>
                        <td>
                          {values.penaltyname === "ปกติ" ? (
                            <span className="badge bg-success">
                              {" "}
                              {values.penaltyname}
                            </span>
                          ) : values.penaltyname === "ใบแดง" ? (
                            <span className="badge bg-danger">
                              {" "}
                              {values.penaltyname}
                            </span>
                          ) : (
                            <span className="badge bg-warning">
                              {" "}
                              {values.penaltyname}
                            </span>
                          )}
                        </td>
                        <td>
                          {values.CkCovid ? (
                            <span className="badge bg-success">
                              {" "}
                              ผ่านประเมิน{" "}
                            </span>
                          ) : (
                            <span className="badge bg-danger">
                              {" "}
                              ไม่ผ่าน{" "}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="mytooltip tooltip-effect-1">
                            <span className="tooltip-item">
                              <span className="d-none d-md-inline text-black pr-2">
                                <img
                                  alt=""
                                  className="rounded-circle ms-2"
                                  src={values.url + "&size=320"}
                                  style={{
                                    width: "100%",
                                    maxHeight: 50,
                                    maxWidth: 50,
                                  }}
                                />
                              </span>
                            </span>

                            <span className="tooltip-content clearfix">
                              <img
                                alt=""
                                className="rounded-circle ms-2"
                                src={values.url + "&size=320"}
                                style={{
                                  width: "100%",
                                  minHeight: "300px",
                                  minWidth: "300px",
                                }}
                              />

                              <span className="tooltip-text"></span>
                            </span>
                          </div>
                        </td>
                        <td>
                          {values.timein ? (
                            <span className="badge bg-warning">
                              {" "}
                              {values.timein}{" "}
                            </span>
                          ) : null}
                        </td>
                        <td>
                          {values.timeout ? (
                            <span className="badge bg-warning">
                              {" "}
                              {values.timeout}{" "}
                            </span>
                          ) : null}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
            )}

            {list && list.AssetList && (
              <table className="table table-striped table-hover">
                <thead>
                  <tr style={{ fontSize: "14px" }}>
                    <th scope="col">
                      <FontAwesome name="cog" />
                    </th>
                    <th scope="col">สินค้า</th>
                    <th scope="col">จำนวน</th>
                    <th scope="col">หน่วย</th>
                    <th scope="col">PO</th>
                  </tr>
                </thead>
                <tbody>
                  {list && list.AssetList ? (
                    list.AssetList.map((values) => (
                      <tr key={values.id} style={{ fontSize: "14px" }}>
                        <td>{values.id}</td>
                        <td>{values.AssetName}</td>
                        <td>{values.Amount}</td>
                        <td>{values.UnitName}</td>
                        <td>{values.PO}</td>
                      </tr>
                    ))
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PermitList;
